class Distribucio {
    constructor(
        public id= 0,
        public key= 0,
        public tipus= 0,
        public valor= 0,
        public interv= 0,
        public id_proveidor= 0,
        public dia_set= 0
    ) {
        this.id = id;
        this.key = key;
        this.tipus = tipus;
        this.valor = valor;
        this.interv = interv;
        this.id_proveidor = id_proveidor;
        this.dia_set = dia_set; 
    }
}
export default Distribucio;
